import { useGetShelvesQuery } from '@/services/shelves';

import ShelfCarrousel from './ShelfCarrousel';

const Shelves = () => {
  const { data, isFetching } = useGetShelvesQuery();
  if (isFetching) return null;

  return (
    <>
      {data?.map((shelf, index, arr) => (
        <ShelfCarrousel key={shelf.id} index={arr.length - index} id={shelf.id} title={shelf.title} />
      ))}
    </>
  );
};

export default Shelves;
